export class Product365 {
    name
    importance
    

    constructor() {
        this.name = "Keine Auswahl"
        this.importance = -1     
    }

    get() {
        return {
            name: this.name,
            importance: this.importance,
        }
    }

    updateNameAndImportance(name, importance) {
        if(importance > this.importance) {
            this.name = name
            this.importance = importance
        }
    }

    updateName(name) {
        this.name = name
    }

    // addOption(optionName) {
    //     this.options.push(optionName)
    // }



}